import { transformContext } from "../../common";
import { useCallback } from "react";
import { useLDClient, useFlags as useLDFlagsHook, } from "launchdarkly-react-client-sdk";
/**
 * The `useFlags` is a custom hook which returns all flags. Use a HOC at the root of your application before using the hook.
 *
 * @return All the flags configured in your project
 */
export const useFlags = useLDFlagsHook;
/**
 * If your app does not yet have the context when you call the provider or if the context has changed since then,
 * you can evaluate the context with this custom hook. Changing the current context also causes all feature flag
 * values to be reloaded. Use a HOC at the root of your application before using the hook.
 *
 * @returns A set of flag values for the newly provided context or `undefined` if client is not ready
 */
export const useContextEvaluation = () => {
    const ldClient = useLDClient();
    const evaluate = useCallback((context) => ldClient?.identify(transformContext(context)), [ldClient]);
    return {
        evaluate,
    };
};
